import { AppBanner } from './AppBanner';

export default AppBanner;
